module.exports = __webpack_public_path__ + "img/svi_white.4d550d95.jpg";